export default "__VITE_ASSET__BYkuMRA1__"